import { render, staticRenderFns } from "./VuetifyDatePicker.vue?vue&type=template&id=161e9e16"
import script from "./VuetifyDatePicker.vue?vue&type=script&lang=js"
export * from "./VuetifyDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports